import { Component, Input } from '@angular/core';

@Component({
  selector: 'font-awesome-icon',
  templateUrl: './font-awesome-icon.component.html',
  styleUrls: ['./font-awesome-icon.component.scss'],
  host: {
    ngSkipHydration: 'true',
  },
  standalone: false,
})
export class FontAwesomeIconComponent {
  @Input()
  icon: string | null = '';
}
